import script from "./ExhibitionCoordinatePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./ExhibitionCoordinatePicker.vue?vue&type=script&setup=true&lang=js"

import "./ExhibitionCoordinatePicker.vue?vue&type=style&index=0&id=002043ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-002043ec"]])

export default __exports__